import { FC, SVGProps } from 'react'

import { LeadSource } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import {
  IconAirbnb,
  IconAirbnbRectangle,
  IconAvantStayLogo,
  IconAvantstayRectangle,
  IconBookingCom,
  IconBookingComRectangle,
  IconExpedia,
  IconExpediaRectangle,
  IconGoogleTravel,
  IconGoogleTravelRectangle,
  IconHomesAndVillasRectangle,
  IconHomeToGoRectangle,
  IconHopper,
  IconHopperRectangle,
  IconHotelTonight,
  IconHotelTonightRectangle,
  IconMarriott,
  IconMarriottRectangle,
  IconQuintess,
  IconQuintessRectangle,
  IconTopVillasRectangle,
  IconTravelStaytionRectangle,
  IconTripAdvisorRectangle,
  IconVacationRenterRectangle,
  IconVrbo,
  IconVRBORectangle,
  IconWheelhouseRectangle,
  IconWhimstayRectangle,
} from '@avantstay/backoffice-vectors'

import { externalColors, mainColors } from '../styles'

export type IconLeadSource = keyof typeof iconByLeadSource

export const iconByLeadSource: Record<
  string,
  { label: string; icon: FC<React.SVGProps<SVGSVGElement>> }
> = {
  AVANTSTAY: { label: 'AvantStay', icon: IconAvantstayRectangle },
  AS_DIRECT: { label: 'Website', icon: IconAvantstayRectangle },
  LIGHTHOUSE: { label: 'LightHouse', icon: IconAvantstayRectangle },
  WEBSITE: { label: 'Website', icon: IconAvantstayRectangle },
  VOYAGE: { label: 'Voyage', icon: IconAvantstayRectangle },
  AIR_BNB: { label: 'Airbnb', icon: IconAirbnbRectangle },
  VRBO: { label: 'VRBO', icon: IconVRBORectangle },
  BOOKING_COM: { label: 'Booking.com', icon: IconBookingComRectangle },
  EXPEDIA: { label: 'Expedia', icon: IconExpediaRectangle },
  GOOGLE_TRAVEL: { label: 'Google Travel', icon: IconGoogleTravelRectangle },
  HOME_TO_GO: { label: 'HomeToGo', icon: IconHomeToGoRectangle },
  HOMES_AND_VILLAS: { label: 'Homes&Villas', icon: IconHomesAndVillasRectangle },
  HOPPER: { label: 'Hopper', icon: IconHopperRectangle },
  HOTEL_TONIGHT: { label: 'HotelTonight', icon: IconHotelTonightRectangle },
  MARRIOTT: { label: 'Marriott', icon: IconMarriottRectangle },
  QUINTESS: { label: 'Quintess', icon: IconQuintessRectangle },
  TOP_VILLAS: { label: 'Top Villas', icon: IconTopVillasRectangle },
  TRAVEL_STAYTION: { label: 'TravelStaytion', icon: IconTravelStaytionRectangle },
  TRIP_ADVISOR: { label: 'TripAdvisor', icon: IconTripAdvisorRectangle },
  VACATION_RENTER: { label: 'VacationRenter', icon: IconVacationRenterRectangle },
  WHEELHOUSE: { label: 'Wheelhouse', icon: IconWheelhouseRectangle },
  WHIMSTAY: { label: 'Whimstay', icon: IconWhimstayRectangle },
} satisfies Record<string, { label: string; icon: FC<SVGProps<SVGSVGElement>> }>

export const backgroundColorByLeadSource: Record<string, string> = {
  [LeadSource.airBnb]: externalColors.airbnbLogo,
  AS_DIRECT: mainColors.primaryMedium,
  AVANTSTAY: mainColors.primaryMedium,
  [LeadSource.acqDirect]: mainColors.primaryMedium,
  [LeadSource.bookingCom]: externalColors.bookingComLogo,
  [LeadSource.capitalOne]: mainColors.primaryMedium,
  [LeadSource.expedia]: externalColors.expediaLogo,
  [LeadSource.googleTravel]: mainColors.white,
  [LeadSource.hopper]: externalColors.hopperLogo,
  [LeadSource.hotelTonight]: externalColors.hotelTonightLogo,
  [LeadSource.lighthouse]: mainColors.primaryMedium,
  [LeadSource.marriott]: externalColors.marriottLogo,
  [LeadSource.quintess]: externalColors.quintessLogo,
  [LeadSource.voyage]: mainColors.primaryMedium,
  [LeadSource.vrbo]: externalColors.vrboLogo,
  [LeadSource.website]: mainColors.primaryMedium,
}

export const iconByLeadSourceCircle: Record<
  string,
  { label: string; icon: FC<SVGProps<SVGSVGElement>> }
> = {
  AVANTSTAY: { label: 'AvantStay', icon: IconAvantStayLogo },
  AS_DIRECT: { label: 'Website', icon: IconAvantStayLogo },
  [LeadSource.acqDirect]: { label: 'Website', icon: IconAvantStayLogo },
  [LeadSource.lighthouse]: { label: 'LightHouse', icon: IconAvantStayLogo },
  [LeadSource.website]: { label: 'Website', icon: IconAvantStayLogo },
  [LeadSource.voyage]: { label: 'Voyage', icon: IconAvantStayLogo },
  [LeadSource.airBnb]: { label: 'Airbnb', icon: IconAirbnb },
  [LeadSource.vrbo]: { label: 'VRBO', icon: IconVrbo },
  [LeadSource.bookingCom]: { label: 'Booking.com', icon: IconBookingCom },
  [LeadSource.expedia]: { label: 'Expedia', icon: IconExpedia },
  [LeadSource.googleTravel]: { label: 'Google Travel', icon: IconGoogleTravel },
  [LeadSource.homeAway]: { label: 'VRBO', icon: IconVrbo },
  [LeadSource.hopper]: { label: 'Hopper', icon: IconHopper },
  [LeadSource.hotelTonight]: { label: 'HotelTonight', icon: IconHotelTonight },
  [LeadSource.marriott]: { label: 'Marriott', icon: IconMarriott },
  [LeadSource.quintess]: { label: 'Quintess', icon: IconQuintess },
}
